import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findRole({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`role/findRole`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	save({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`role/save`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`role/findById`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  deleteById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`role/deleteById`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  
  findCurrentUserVisibleRole({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`role/findCurrentUserVisibleRole`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  
}
